import PropTypes from 'prop-types';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useChatbotContext } from '../../../hooks/ChatbotContext';
import ChatBadge from '../ChatBadge';
import ChatButton from '../ChatButton';
import './ChatHeader.scss';

function ChatHeader({ onClose, onCollapse, onToggleHistory, historyButtonRef, showLeftContent = true, showCenterContent = true }) {
  const { t } = useTranslation(['chatbot']);
  const { mode } = useChatbotContext();

  // Use onCollapse if provided, otherwise fall back to onClose
  const handleCloseClick = onCollapse || onClose;

  return (
    <div className="chat-header-container">
      <div className="chat-header">
        <div className="chat-header__left">
          {showLeftContent && mode === 'study' && (
            <>
              <ChatButton
                ref={historyButtonRef}
                variant="text"
                color="brand"
                onClick={onToggleHistory}
                icon="replay-history"
                iconPosition="iconOnly"
                className="chat-header__history-button"
                title={t('chatbot:History')}
              />
              {/* No hay settings que mostrar porque la opción de Habilitar búsqueda web queda relegada a feature flag en el backend
              <div className="chat-header__divider" />
              <ChatButton
                ref={settingsButtonRef}
                variant="text"
                color="brand"
                onClick={onToggleSettings}
                icon="more-bullets"
                iconPosition="iconOnly"
                className="chat-header__settings-button"
                title={t('chatbot:Settings')}
              /> */}
            </>
          )}
        </div>

        <div className="chat-header__center">
          {showCenterContent && (
            <div className="chat-header__mode">
              <ChatBadge variation={mode} />
            </div>
          )}
        </div>

        <div className="chat-header__right">
          {(mode === 'study' || mode === 'teacher-tools') && (
            <ChatButton
              variant="outlined"
              color="brand"
              onClick={handleCloseClick}
              icon="close"
              iconPosition="iconOnly"
              className="chat-header__close-button"
              title={onCollapse ? t('chatbot:Collapse') : t('chatbot:Close')}
            />
          )}
        </div>
      </div>
    </div>
  );
}

ChatHeader.propTypes = {
  onClose: PropTypes.func.isRequired,
  onCollapse: PropTypes.func,
  onToggleHistory: PropTypes.func,
  showHistory: PropTypes.bool,
  showSettings: PropTypes.bool,
  historyButtonRef: PropTypes.object,
  showLeftContent: PropTypes.bool,
  showCenterContent: PropTypes.bool,
};

ChatHeader.defaultProps = {
  onClose: () => {},
  onToggleHistory: () => {},
  showHistory: false,
  showSettings: false,
  historyButtonRef: null,
  showLeftContent: true,
  showCenterContent: true,
};

export default ChatHeader;
